import { render, staticRenderFns } from "./hehuaCulture.vue?vue&type=template&id=7e47d5f0&scoped=true&"
import script from "./hehuaCulture.vue?vue&type=script&lang=js&"
export * from "./hehuaCulture.vue?vue&type=script&lang=js&"
import style0 from "./hehuaCulture.vue?vue&type=style&index=0&id=7e47d5f0&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e47d5f0",
  null
  
)

export default component.exports